export default function initMenu() {
  const header = document.querySelector("#js-header");
  const menu = document.querySelector("#js-menu-sandwich");
  if (header && menu) {
    menu.addEventListener("click", () => {
      header.classList.toggle("menu-open");
    });
  }
}
